import React, { useEffect } from 'react';
import { Box, Grid, Typography, styled, Container, Stack } from '@mui/material';
import logo from '../images/CC Icon.png';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';

const StyledFooterLink = styled(Typography)(({ theme }) => ({
  textDecoration: 'none',
  color: 'white',
  fontFamily: '"Montserrat", sans-serif',
  fontWeight: 400,
  fontSize: '0.95rem',
  opacity: '0.85',
  transition: 'opacity 0.3s ease, color 0.3s ease',
  '&:hover': {
    color: '#a974d0',
    opacity: '1',
  },
  '& a': {
    textDecoration: 'none',
    color: 'inherit',
  },
}));

const StyledText = styled(Typography)(({ theme }) => ({
  color: 'white',
  fontFamily: '"Montserrat", sans-serif',
  fontSize: '0.9rem',
  opacity: '0.85',
  '& a': {
    color: 'inherit',
    textDecoration: 'none',
    '&:hover': {
      color: '#a974d0',
    },
  },
}));

const SocialIcon = styled('a')(({ theme }) => ({
  color: 'white',
  opacity: '0.85',
  transition: 'opacity 0.3s ease, transform 0.3s ease',
  '&:hover': {
    opacity: '1',
    transform: 'translateY(-2px)',
  },
  margin: '0 12px',
}));

const FooterContainer = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(180deg, #1a1a1a 0%, #000000 100%)',
  padding: '3rem 2rem',
  color: 'white',
  fontFamily: '"Montserrat", sans-serif',
}));

function Footer() {
  useEffect(() => {
    const noSelectElements = document.querySelectorAll('.no-select');
    noSelectElements.forEach((element) => {
      element.style.webkitUserSelect = 'none';
      element.style.mozUserSelect = 'none';
      element.style.msUserSelect = 'none';
      element.style.userSelect = 'none';
    });
  }, []);

  return (
    <FooterContainer>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={4}
          justifyContent="space-between"
          alignItems="center"
        >
          {/* Logo and Description */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: { xs: 'center', md: 'flex-start' },
              textAlign: { xs: 'center', md: 'left' },
            }}
          >
            <Box mb={2}>
              <img src={logo} height="80px" width="auto" alt="footerLogo" />
            </Box>
            <div className="no-select">
              <Typography
                sx={{
                  color: 'white',
                  fontFamily: '"Montserrat", sans-serif',
                  fontSize: '0.95rem',
                  lineHeight: '1.6',
                  opacity: '0.9',
                  textAlign: 'justify',
                  maxWidth: { xs: '100%', md: '80%' },
                }}
              >
                CC Software Solutions is a leading software engineering company specializing in the development of mobile apps, POS systems, and web applications. With a focus on innovation and quality, we deliver cutting-edge solutions to meet our clients' needs.
              </Typography>
            </div>
          </Grid>
          
          {/* Contact and Social Icons */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: { xs: 'center', md: 'flex-end' },
              textAlign: { xs: 'center', md: 'right' },
            }}
          >
            <Stack direction="column" spacing={1} sx={{ mb: 3 }}>
              <Stack direction="row" alignItems="center" justifyContent={{ xs: 'center', md: 'flex-end' }} spacing={1}>
                <LocalPhoneIcon sx={{ color: 'white', opacity: '0.85', fontSize: '1.1rem' }} />
                <StyledText>
                  <a href="tel:+94770832340">+94 770 832 340</a>
                </StyledText>
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent={{ xs: 'center', md: 'flex-end' }} spacing={1}>
                <EmailIcon sx={{ color: 'white', opacity: '0.85', fontSize: '1.1rem' }} />
                <StyledText>
                  <a href="mailto:info@ccsoftwares.com">info@ccsoftwares.com</a>
                </StyledText>
              </Stack>
            </Stack>

            <Box>
              <SocialIcon href="https://www.facebook.com/profile.php?id=61555503735807" target="_blank">
                <FacebookIcon />
              </SocialIcon>
              <SocialIcon href="https://www.instagram.com/ccsoftwares?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank">
                <InstagramIcon />
              </SocialIcon>
              <SocialIcon href="#" target="_blank">
                <YouTubeIcon />
              </SocialIcon>
              <SocialIcon href="#" target="_blank">
                <XIcon />
              </SocialIcon>
            </Box>
          </Grid>
        </Grid>
      </Container>
      
      {/* Copyright */}
      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <hr style={{ opacity: '0.3', margin: '2rem auto', maxWidth: '1200px' }} />
        <Typography
          sx={{
            color: 'white',
            fontFamily: '"Montserrat", sans-serif',
            fontSize: { xs: '0.85rem', md: '0.9rem' },
            opacity: '0.7',
          }}
        >
          Copyright © 2024 <b>CC Software Solutions</b> All Rights Reserved
        </Typography>
      </Box>
    </FooterContainer>
  );
}

export default Footer;